'use client';

import { useEffect, useMemo, useState } from 'react';
import {
  hasHarDecodedBodyView,
  resolveStoredHarRequestDisplayContent,
  resolveStoredHarResponseDisplayContent,
  type HarGrpcBodyView,
  type StoredHarDisplayEntry,
} from '@terra/shared-utils';

type UseHarEntryHttpDisplayParams = {
  harEntry: StoredHarDisplayEntry;
  viewResetKey?: string;
};

export function useHarEntryHttpDisplay({
  harEntry,
  viewResetKey,
}: UseHarEntryHttpDisplayParams) {
  const [bodyView, setBodyView] = useState<HarGrpcBodyView>('decoded');

  useEffect(() => {
    setBodyView('decoded');
  }, [viewResetKey]);

  const hasDecodedBodyView = useMemo(
    () => hasHarDecodedBodyView({ harEntry }),
    [harEntry],
  );

  const requestContent = useMemo(
    () => resolveStoredHarRequestDisplayContent({ harEntry, bodyView }),
    [bodyView, harEntry],
  );

  const responseContent = useMemo(
    () => resolveStoredHarResponseDisplayContent({ harEntry, bodyView }),
    [bodyView, harEntry],
  );

  return {
    bodyView,
    setBodyView,
    hasDecodedBodyView,
    requestContent,
    responseContent,
  };
}
